import { render, staticRenderFns } from "./SpaceGeometryViz.vue?vue&type=template&id=a80537b2&scoped=true"
import script from "./SpaceGeometryViz.vue?vue&type=script&lang=js"
export * from "./SpaceGeometryViz.vue?vue&type=script&lang=js"
import style0 from "./SpaceGeometryViz.vue?vue&type=style&index=0&id=a80537b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80537b2",
  null
  
)

export default component.exports